import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=2034cfba&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=2034cfba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034cfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2034cfba')) {
      api.createRecord('2034cfba', component.options)
    } else {
      api.reload('2034cfba', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=2034cfba&scoped=true&", function () {
      api.rerender('2034cfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lw2XC6x8KdmS/JS/comp/DocBox.vue"
export default component.exports